import { exeRequest } from '../utils/APIUtils';

// Service d'authentification client
export const authService = {
    login: async (data) => exeRequest('/website/clients/login', 'POST', data),
    forgotPassword: async (data) => exeRequest('/website/clients/forgot-password', 'POST', data),
};

// Service espace client
export const clientService = {
    getDashboard: async () => exeRequest('/website/clients/dashboard', 'GET'),
    getContrats: async () => exeRequest('/website/clients/contrats', 'GET'),
    getContratDetail: async (id) => exeRequest(`/website/clients/contrats/${id}`, 'GET'),
    getSituation: async () => exeRequest('/website/clients/situation', 'GET'),
    getSinistres: async () => exeRequest('/website/clients/sinistres', 'GET'),
    declarerSinistre: async (data) => exeRequest('/website/clients/sinistres', 'POST', data),
    getAttestation: async (contratId) => exeRequest(`/website/clients/attestations/${contratId}`, 'GET'),
};

// Service pour les donnees publiques (types d'assurance, agences, etc.)
export const publicService = {
    getTypesAssurance: async () => exeRequest('/admin/types-assurance', 'GET'),
    getAgences: async () => exeRequest('/admin/agences', 'GET'),
    getCompagnies: async () => exeRequest('/admin/compagnies', 'GET'),
};
